/**
 * Turns a website saved on a contact into a URL that is safe to open: anything that is not already
 * http(s) is prefixed with https://, so a shared contact cannot carry a javascript: or data: link.
 */
export const getWebsiteUrl = (website?: string) => {
  const trimmedWebsite = website?.trim() ?? "";
  if (!trimmedWebsite) return "";
  return /^https?:\/\//i.test(trimmedWebsite) ? trimmedWebsite : `https://${trimmedWebsite}`;
};
